import React from "react";
import { Link } from "react-router-dom";

const AlbumDesign = () => {
  return (
    <div className="mx-5">
      {/* --------Second Carousel----------- */}
      <div className="row justify-content-center align-items-center my-5">
        <div className="col-md-8">
          <div
            id="carouselContemporary"
            className="carousel slide"
            data-bs-ride="carousel"
            data-bs-interval="2000"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src="/images/1 (2).png"
                  className="d-block w-100"
                  style={{ height: "400px", objectFit: "cover" }}
                  alt="Contemporary Album"
                />
              </div>
              <div className="carousel-item">
                <img
                  src="/images/1 (3).png"
                  className="d-block w-100"
                  style={{ height: "400px", objectFit: "cover" }}
                  alt="Elegant Album"
                />
              </div>
              <div className="carousel-item">
                <img
                  src="/images/1 (7).png"
                  className="d-block w-100"
                  style={{ height: "400px", objectFit: "cover" }}
                  alt="Elegant Album"
                />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselContemporary"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselContemporary"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div className="col-md-4 ps-5">
          <h2 className="prata-regular mb-4">
            Contemporary, Elegant & Blended
          </h2>
          <p>
            <b>Contemporary:</b> Includes fading images, graphics, clipart,
            color backgrounds, and extra design elements.
          </p>
          <p>
            <b>Elegant:</b> Faded images with thin outlines, minimalistic, no
            extra elements.
          </p>
          <p>
            <b>Blended:</b> Use of overlapping, image blending, and background
            imagery.
          </p>
        </div>
        <div className="my-5 d-flex justify-content-center">
          <Link
            to={"/albumdesign-order"}
            className="btn bg_maincolor text-white"
          >
            Order Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AlbumDesign;
